<div class="dropdown">
    <button class="btn btn-custom-toggle dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
        {{ selectedItem === '' ? labelField : selectedItem}} 
    </button>
    <div class="dropdown-menu">
      <a class="dropdown-item"  *ngFor="let lang of items" (click)="onChangeSelectedItem(lang.value)">{{ lang.value.toUpperCase() }}</a>
    </div>
  </div>